import React from "react";
import cx from "classnames";
import { Button, ChevronDownIcon } from "@picklebet/ui";
import * as support from "utilities/support";

import * as styles from "./SupportLink.module.scss";

type SearchSupport = {
  search: string;
  labels?: never;
  articleId?: never;
};

type LabelsSupport = {
  search?: never;
  labels: string[];
  articleId?: never;
};

type ArticleIdSupport = {
  search?: never;
  labels?: never;
  articleId: string;
};

export type SupportOptions = SearchSupport | LabelsSupport | ArticleIdSupport;

type SupportLinkProps = {
  className?: string;
  options?: SupportOptions;
  type?: "text" | "button";
  children?: React.ReactNode;
  hideChevron?: boolean;
  openLiveChat?: boolean;
  loading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  title?: string;
};

const SupportLink = ({
  type = "text",
  className,
  options,
  children,
  hideChevron = false,
  openLiveChat = false,
  loading = false,
  onClick,
  title,
}: SupportLinkProps) => {
  return (
    <Button
      skeleton={loading}
      className={cx(styles.link, className)}
      variant={type === "button" ? `primary` : `link`}
      title={title}
      onClick={(event) => {
        if (openLiveChat) {
          support.openWithChat();
        } else {
          support.open(options);
        }

        if (onClick) {
          onClick(event);
        }
      }}
    >
      {children}
      {!hideChevron && (
        <span className={styles.icon}>
          <ChevronDownIcon />
        </span>
      )}
    </Button>
  );
};

export { SupportLink };
